import React, { useState } from "react";
import "./styles/Contact.css";

const Contact = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  console.log(apiUrl);
  const [popup, setPopup] = useState(null);


  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "Demande de devis",
    message: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
  
    if (!formData.name.trim() || !formData.email.trim() || !formData.message.trim()) {
      alert("Merci de remplir les champs obligatoires : nom, email et message.");
      return;
    }
  
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      alert("L'adresse email n'est pas valide.");
      return;
    }
  
    try {
      const response = await fetch(`${apiUrl}/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.message || "Erreur lors de l'envoi du message.");
      }
  
      setPopup({ type: "success", message: "Votre message a bien été envoyé !" });
      setFormData({
        name: "",
        email: "",
        phone: "",
        subject: "Demande de devis",
        message: "",
      });
  
    } catch (error) {
      setPopup({ type: "error", message: "Erreur lors de l'envoi du message" });
    }
  };  

  const Popup = ({ message, type, onClose }) => {
    return (
      <div className={`popup-overlay`}>
        <div className={`popup-box popup-${type}`}>
          <p>{message}</p>
          <button onClick={onClose}>OK</button>
        </div>
      </div>
    );
  };  

  return (
    <main className="contact-container">
        {popup && (
            <Popup
                message={popup.message}
                type={popup.type}
                onClose={() => setPopup(null)}
            />
        )}
      <section className="contact-header">
        <h1>Contactez-nous pour un devis ou une intervention</h1>
        <p>
          Une question, un besoin, un chantier en préparation ?
          Remplissez ce formulaire, nous vous recontactons sous 24h.
        </p>
      </section>

      <section className="contact-form-section">
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="contact-field">
            <label htmlFor="name">Nom complet *</label>
            <input
              type="text"
              id="name"
              name="name"
              required
              value={formData.name}
              onChange={handleChange}
            />
          </div>

          <div className="contact-field">
            <label htmlFor="email">Adresse email *</label>
            <input
              type="email"
              id="email"
              name="email"
              required
              value={formData.email}
              onChange={handleChange}
            />
          </div>

          <div className="contact-field">
            <label htmlFor="phone">Téléphone</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>

          <div className="contact-field">
            <label htmlFor="subject">Sujet *</label>
            <select
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
            >
              <option>Demande de devis</option>
              <option>Renseignement</option>
              <option>Urgence</option>
              <option>Autre</option>
            </select>
          </div>

          <div className="contact-field">
            <label htmlFor="message">Message *</label>
            <textarea
              id="message"
              name="message"
              rows="5"
              required
              value={formData.message}
              onChange={handleChange}
            ></textarea>
          </div>

          <button type="submit" className="contact-submit">
            Envoyer ma demande
          </button>
        </form>

        <div className="contact-infos">
          <h2>Informations utiles</h2>
          <p><strong>Email :</strong> contact@dctp.fr</p>
          <p><strong>Téléphone :</strong> 06 15 85 85 22</p>
          <p><strong>Zone d'intervention :</strong> Occitanie et Nouvelle-Aquitaine</p>
        </div>
      </section>
    </main>
  );
};

export default Contact;
